module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-1250-Inactive-Rumble-5093b3cd06a8b738c5f9232b11b2e213.png";